const SCROLL_ALERT_CLASS = "scrollable-alert";
const ALERT_BOX_CLASS = "alert-box";
const ALERT_TEXT = "Drag left or right to reveal more columns";

const MOBILE_BREAKPOINT = 540;
const DEBOUNCE_DELAY = 150;
const VISIBLE_DELAY = 150;
const FADE_OUT_DELAY = 2250;
const REMOVE_DELAY = 500;

const observer = new IntersectionObserver(
   (entries) => {
      entries.forEach(({ isIntersecting, target: table }) => {
         if (!isIntersecting) return;

         const alert = table.nextElementSibling;

         if (
            !alert?.classList.contains(SCROLL_ALERT_CLASS) ||
            alert.hasAttribute("data-started")
         ) {
            return;
         }

         alert.setAttribute("data-started", "");

         setTimeout(() => {
            alert.classList.add("visible");
         }, VISIBLE_DELAY);

         setTimeout(() => {
            alert.classList.add("fade-out");

            setTimeout(() => {
               alert.remove();
            }, REMOVE_DELAY);
         }, FADE_OUT_DELAY);

         observer.unobserve(table);
      });
   },
   {
      threshold: 0.25,
   }
);

function createScrollAlert() {
   const alert = document.createElement("div");
   alert.className = SCROLL_ALERT_CLASS;

   const box = document.createElement("div");
   box.className = ALERT_BOX_CLASS;

   const text = document.createElement("p");
   text.textContent = ALERT_TEXT;

   box.append(text);
   alert.append(box);

   return alert;
}

function checkTables() {
   const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

   document.querySelectorAll("div > table").forEach((table) => {
      const wrapper = table.parentElement;
      const alert = table.nextElementSibling;

      if (!wrapper) return;

      const hasOverflow = table.scrollWidth > wrapper.clientWidth;

      if (!isMobile || !hasOverflow) {
         if (alert?.classList.contains(SCROLL_ALERT_CLASS)) {
            alert.remove();
         }

         observer.unobserve(table);
         return;
      }

      if (alert?.classList.contains(SCROLL_ALERT_CLASS)) {
         return;
      }

      table.insertAdjacentElement(
         "afterend",
         createScrollAlert()
      );

      observer.observe(table);
   });
}

function debounce(fn, delay) {
   let timer;

   return () => {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
   };
}

function initTableScrollAlert() {
   const handleResize = debounce(checkTables, DEBOUNCE_DELAY);

   window.addEventListener("resize", handleResize);
   window.addEventListener("orientationchange", handleResize);

   if (document.readyState === "complete") {
      checkTables();
   } else {
      window.addEventListener("load", checkTables, { once: true });
   }
}

export default initTableScrollAlert;